export default __webpack_public_path__ + "static/media/subscribe.6c9b8abd.svg";